export const PublishedArtists = [
  "frenzy",
  "hecatomb",
  "kisimen",
  "monaca",
  "muscle",
  "ogtk",
  "ophill",
  "qulague",
  "goodbye",
  "iramina",
  "sakae",
  "mebae",
  "yuinisio",
  "hirotyo",
  "nkwors",
  "3cm",
  "aysula",
  "fuzzklaxon",
  "modern",
  "posake",
  "sedwig",
  "sukida",
  "tamiw",
  "ulm",
  "katsuwe",
  "souvenir",
  "zerone",
  "tsubu",
  "pari",
  "michikusa",
  "kondo",
]

export const ArtistDefinitions = [
  {
    id: "qulague",
    img: "qulague.jpg",
    name: "qulague",
    message:
      "ハポンとDAYTRIPは、どちらも信頼できる人と場所がある、それぞれに唯一無二の遊び場です。\n 僕らqulagueにとってそうですし、この企画に賛同する人達みんなにとって、そうあるはずです。\n この大切な場所を守るためのコンピレーション、たくさん聴いてください。",
  },
  {
    id: "ophill",
    img: "ophill.jpg",
    name: "ophill",
    message: `ライブが終わってステージ撤収に来るモモジさんに「今日どうでした？」と聞く。荷物をまとめてトチギさんに「今日どうでした？」と聞く。帰りに挨拶をしてメンバーで「次こうしよ」と話す。
    これから先もこれを続けたい。
    ハポンが必要です。`,
  },
  {
    id: "yuinisio",
    img: "yuinisio.jpg",
    name: "ゆいにしお",
    message: `ゆいにしおとしてライブハウスに立ったのは、鶴舞DAYTRIPが初めてでした。サークル外での活動を始めたばかりのわたしにとって、ライブハウスで演奏する経験を積み、アーティストとの出会いもあった貴重な場所です。
    そうして活動していく中で、鶴舞KDハポンは、いつしかわたしのホームのような場所となりました。
    数々の自主企画も、モモジさんはじめ、スタッフのみなさんのおかげでお客さんが楽しんでいる光景を見ることもできました。

    上京した今でも、鶴舞駅を降りて、重いギターを引きずりながらも、高架下をまっすぐに歩く風景をよく思い出します。
    ビールをたくさん飲んで、良い演奏に拍手や喝采を送る日がまた訪れますように。`,
  },
  {
    id: "ogtk",
    img: "ogtk.jpg",
    name: "Ogawa & Tokoro",
    message: `私たちのように宅録による音源制作をメインとしている人間にとって、鶴舞DAYTRIPやK.Dハポンのような、やさしくて居心地のよいライブハウスはとても大切な場所であるように思います。これからもぜひよろしくお願いいたします。`,
  },
  {
    id: "monaca",
    img: "monaca.jpg",
    name: "Monaca yellow city",
    message: `ハポンにはもーのすごくお世話になってます。モナカでの活動のスタートからリリースパーティーまで、あらゆることをお世話していただきました。微力かもしれませんが、好きな場所を守りたいので、お力になれたらと思います。近い未来の愛と平和を祈っています。`,
  },
  {
    id: "souvenir",
    img: "souvenir.jpg",
    name: "スーベニア",
    message: `バンド結成から、酸いも甘いも、たくさんのライブ経験させてもらい、ずっとお世話になってきましたし、これからもがっつりお世話になる気満々です！自分らの作ったものが価値になり、それで支援ができるならこれほど嬉しいことはないです。何かできたらと思っていたなか、真っ先に企画を組み機会をくれた辻さん薫人さん、ありがとうございます。何よりも価値になるべくいい曲を寄せられたらと思います。スーベニア和田`,
  },
  {
    id: "hecatomb",
    img: "hecatomb.jpg",
    name: "HECATOMB",
    message: `KD JAPONは、出演者としてはDOIMOIの初ライブ（2005年）以来いろんな名義で長らく、観るほうとしてはそれより前の小規模招聘ラッシュの頃（2000年代前半）からお世話になっている、個人的には一番縁深いと思っているライブ会場です。DAYTRIPはさらに前の学生時代、バンドサークルの人達を見に行ったり、同じ頃に今思えばレアな形で出演もしていたり、バンド人生最初期の記憶に大きく登場する場所です。HELDONやマニ・ノイマイヤーを観たのも思い出深い…
    今回こういう形で、サポートを募る側に協力させてもらえることになり、主宰チームの行動力には頭が下がるとともに、機会をもらえたことに多大な感謝を表したいと思います。確かひとまわりくらいは若い彼ら（ワタシは大学のバンドサークルの遠い先輩にあたります）とその世代の人々に向けて何かするなら…と考えた末、どちらの会場でもライブをやったことがない昔の宅録ブラックメタル名義で参加することにしてみました。合ってるのかな！わかりませんが！旧世代メタラーより思いを込めて。`,
  },
  {
    id: "ulm",
    img: "ulm.jpg",
    name: "Ulm",
    message: `今回、この素敵な企画のお誘いを頂きとても嬉しく思います。ありがとうございます。
    「光溢れる明るい日々を願う」をテーマに作曲した楽曲で参加させて頂きます。
    演奏したり遊んだりと普段あった日常に戻る事を祈っております。
    無責任な事を発言する事許して頂きたいのですが、ライブハウス負けないで欲しいです。

    Ulm/ユウマカネコ`,
  },
  {
    id: "muscle",
    img: "muscle.jpg",
    name: "Muscle Soul",
    message:
      "Muscle Soulは、これまで鶴舞DAYTRIPと長く関わらせて頂いてきました。昨今の世界の情勢、日本の情勢に伴う混乱の中、様子を見ていることしか出来ずにいた中、ここで大きく声を上げてくれたのが、僕よりも若い名古屋を代表するミュージシャン達で、そのこと自体にすごく励まされました。そして私たちの作品で何か力になれたらと思い、今回参加させて頂きます。今こそ孤独に向き合って考え、智のネットワークを感じて困難に立ち向かっていけたらと思います。",
  },
  {
    id: "frenzy",
    img: "frenzy.jpg",
    name: "frenzy cabbage",
    message: `DAYTRIPには昔からお世話になっていたこともあり、身近な友人がこのような企画を打ってくれたことをとても心強く思いました。「新しい行動を起こす」ということは非常なエネルギーが必要なことであり、それを実行に移した仲間に少しでも協力したく参加させていただきました。
      ハポンに出演し始めたのはDAYTRIPに比べれば最近ではあるのですが、どちらも「所謂 "ライブハウス" っぽくない」人と空間がとても好きで、失いたくない場所です。"繋がり" という意味を込めた曲で、一端の力になれればと思います。`,
  },
  {
    id: "tamiw",
    img: "tamiw.jpg",
    name: "TAMIW",
    message: `鶴舞DAYTRIPさんには、TAMIWでははじめてのアルバムのツアーでお世話になったのが記憶に新しく、もう二年ほど経つのかと感慨深いです。同じくコンピに参加しているMuscle Soulの紹介で何度かこさせていただいていますが、とてもライブハウスらしい雰囲気、スタッフさんの暖かさがとても好きな場所です。私たちにできることはとても少ないですが、できそうなことからやっていきたいという思いから参加させていただきます。皆様と気兼ねなく、元気に再会できる時を楽しみにしております。`,
  },
  {
    id: "fuzzklaxon",
    img: "fuzzklaxon.jpg",
    name: "FUZZKLAXON",
    message: `お世話になっているライブハウスに貢献できる場を与えていただいて感謝します。
    日常の中で大きい音をかき鳴らし、聴き、共有できる場所はライブハウスしかありません。
    この事態を乗り越え、また近いうちにいつも通りライブができることを信じています。`,
  },
  {
    id: "goodbye",
    img: "goodbye.jpg",
    name: "グッドバイモカ",
    message:
      "こういう所に偉そうなコメントをしてしまうと鶴舞のみんなに次会った時「池田ァ、調子乗ってんじゃねぇよ！」って叱られて、その時高井は近くのパーキングに止めた車の中でグースカ寝ていて、ハポンからはカレーの匂いがして、ゆきちゃんラーメンの灯りが付いて、誰かはファミマに煙草を買いに行って、千早交差点に風が吹き抜けて、バリバリ屋は騒がしくて、駅前の蕎麦屋にいる人たちはなんかつまんなさそうで、ライブが始まって、酔っ払って、高井に引きずられながら帰る。",
  },
  {
    id: "modern",
    img: "modern.jpg",
    name: "modern-times",
    message: `本当に微力になってしまいますが、こういう企画に音楽で参加できるというのは嬉しいです！
    modern-timesにとってはやっぱり鶴舞デイトリップは思い出深くて、いろんな出会いがあった大切な場所です！だからこそ、僕はまたそこで楽しくお酒を飲めるって思っていますし、信じています！`,
  },
  {
    id: "3cm",
    img: "3cm.jpg",
    name: "3cm.rhythm",
    message: `次にまたDAYTRIPのステージに立つときのことを考えながら新しい曲を作りました。
    これからもどうぞよろしくお願いします。（ツジ）
    幾度となく素敵なきっかけを与えてくれたDAYTRIPが今まさに存続の危機。それならば、今度は僕らがきっかけとなり、少しでも手助けになれればと思います。（バン）
    私の音楽体験の中でも大きな存在であり、素敵な場所です。感謝の気持ちを込め、応援いたします。（フルタ）
    この大騒ぎが終わったら、またみんなが集まれる場所としてずっと続くことを願います！応援とともに少しだけ協力させてください！（トミタ）`,
  },
  {
    id: "mebae",
    img: "mebae.jpg",
    name: "めばゑ",
    message: `たくさんお世話になった場所に今こそパワーを送ります！！！！`,
  },
  {
    id: "tsubu",
    img: "tsubu.jpg",
    name: "ツブダオ",
    message: `鶴舞DAYTRIP、K.Dハポンは学生時代に音楽活動を初めてから、通してたくさんお世話になり、音楽を通じてたくさんの素敵なミュージシャンに出会えることができた、青春の場所です。こんなちっぽけな存在ですが少しでも力になれたらと思います。`,
  },
  {
    id: "sedwig",
    img: "sedwig.jpg",
    name: "Sedwig",
    message: `大切な場所でこれからも大切な思い出をつくっていきたいです。`,
  },
  {
    id: "pari",
    img: "pari.jpg",
    name: "西尾 大祐",
    message: `今の自分を形成する沢山の思い出がある大好きな場所を守りたい、自分に出来る事は何かと考えていた時にお話を頂き、企画に参加させて頂きました。1日でも早くいつもの風景が戻って来る事を祈っています。`,
  },
  {
    id: "katsuwe",
    img: "katsuwe.jpg",
    name: "かつ江",
    message: `「ライブハウスについて」
    今でこそ人前で「新宿二丁目系シンガーソングライター」と名乗るのもさほど支障ないけれど、はじめたての頃はとんでもない活動をはじめてしまったなと少し後悔すら覚えていた。そもそも、「もうノンケ（異性愛者のこと）のふりをしながら生きていくのも面倒くさいし、ましてどうしてシンガーソングライターとして制作する曲の中ですら、自分にくだらない嘘をつかなければならないのだろう？」そういう思いで始めたこの「新宿二丁目系シンガーソングライター」という活動だったけれど、やはり見ず知らずの人の前で「私は実はゲイなのだ」と打ち明けるのは、抵抗がなかったといったらそんなことはなかった。めちゃめちゃ抵抗があった。毎回呼吸すら忘れそうなほど緊張するのだ。ゲイだということを明かすのは。
    そんな葛藤を抱えたまま、ライブ経験も浅い私にライブハウスからの誘いが飛んできた。デイトリップ。誘ってくれたのは、可愛らしいけどちょっとクレイジーな女の子。その子のイベントは大体、最高の日になる。そういう不思議な女の子。
    あなたが誘うなら、出るっきゃないわねという気持ちでOKすることにした。
    歌い切ったあと、地下ミュージシャンらしく自分で片付ける。すると、PA（岡田さん）がステージにやってきた。うわ！この人めっちゃイケメンで話しかけにくかったんだよな…と思って私は戸惑う。すると彼は右手を差し出して「めちゃくちゃよかったです」と言ってくれた。絶対ノンケなのに！そのとき、少し気づきを得た。
    私、歌っていいのかもしれない。ゲイのままステージに立って、ゲイだ！って歌っても、ノンケからもいいって言ってくれたんだし。音楽ってそういうの関係ないんじゃん。
    プチ気づきを得た私はガンガンデイトリップとかデイトライブとかでライブをした。
    たくさん出会いがあった。
    いつの間にか、人前でゲイだと打ち明けるのも抵抗がなくなっていた。

    あそこで出会った人たちは、宝物です。また会いたいので、ギフトのような気持ちなんだけれど、東京で作った曲をコンピに忍ばせようと思います。かつ江`,
  },
  {
    id: "hirotyo",
    img: "hirotyo.jpg",
    name: "ワタナベヒロト",
    message: `鶴舞DAYTRIP、K.d.ハポン両ライブハウスには名古屋在住時にheadacheなど様々な形態でよくお世話になりました。この2つのライブハウスでのステージを通して生まれた繋がりや衝動が多くありました。様々な自粛が求められている中で、このような形で少しでもお力添え出来ればと思っております。

    今回はバンドではなく宅録形態での音源をリリースさせて頂きます。headacheとは異なる音楽性なので是非ご一聴ください。

    最後に、これを企画した辻と薫人に最大級の賛辞を。`,
  },
  {
    id: "kisimen",
    img: "kisimen.jpg",
    name: "KISIMEN",
    message: `ロストフィルムなどで活動している松岡のソロ「KISIMEN」です。KD JAPONは、2007年頃～僕が初めて自主企画のイベントやり、リリースや何かあればお世話になり続けてきた場所。苦しい時こそ騒ごう！歌おう！踊ろう！`,
  },
  {
    id: "michikusa",
    img: "michikusa.jpg",
    name: "道草",
    message: `ハポンとデイトリ、いずれも思い出深いライブハウスです。初めて行ったライブハウスだったり、大きな自主企画を打った場だったり。私たちの生活を、普通の人達よりちょっぴり豊かなものにしてくれたこの場所を守りたくて、この企画に参加させてもらいました。
    提供させていただいたものは昔の音源ですが、まさに私たちの「自宅」から、力を貸そうじゃありませんか。`,
  },
  {
    id: "posake",
    img: "posake.jpg",
    name: "POSAKE",
    message: `鶴舞DAYTRIPはお客さんとして観に行くだけでなく、サークルのイベントの場としても使わせて頂いてました。あのドープな雰囲気が好きです。
    K.Dハポンは、サークルのホーム的立ち位置であるとともに、私たちがはじめて外でライブをした場でもあります。曲と曲の間に流れる電車の走る音がこんなに心地よく聞けるライブハウスはK.Dハポンだけだと思っています。

    2つの場所は、私たちをいろんな人とつなぎ合わせてくれた大切な場所です。微力ながらも、両ライブハウスの助けになればの思い今回の企画に参加させて頂きました。

    少し堅くなってしまいましたが、何が言いたいかと言うと
    恋もできず、酒もできず、恋もできず…そんな世の中ですが、この場所でまたお酒をみんなで飲めますように💕`,
  },
  {
    id: "sakae",
    img: "sakae.jpg",
    name: "ミヤフジサカヱ",
    message: `お久しぶりです。何か僕にも出来ることがあればと思い声を上げてみました。17の頃から人生の原風景だったあの場所を、絶対になくしてはいけないと思います。`,
  },
  {
    id: "iramina",
    img: "iramina.jpg",
    name: "こみゅにけいしょん",
    message: `愛知を離れ東京に住んでいる今でも、ハポンは友達にとびきり勧めたくなる場所のひとつだ。演奏した日もライブを見に行った日も、素敵な時間を過ごした思い出しかない。
    困難に立ち向かうひとたち、それを支援しようと立ち上がる人たちにリスペクトを込めて、企画に参加させていただきます。`,
  },
  {
    id: "zerone",
    img: "zerone.jpg",
    name: "ゼローネ",
    message:
      "バンドとして演奏した思い出はもちろん、いっぱい飲んでいっぱい笑って、沢山のバンドと出会うきっかけをくれた最高のライブハウスです。\n 微力ながら協力できればと思い、今回企画に参加させていただきました。\n 1日でも早く音楽を聴いて、観て、沢山の人が笑顔になる両ライブハウスが戻って来る事を祈ってます。\n",
  },
  {
    id: "aysula",
    img: "aysula.jpg",
    name: "Aysula",
    message: `名古屋の数あるライブハウスの中で、
    結成当初から一貫してお世話になっている鶴舞デイトリップと
    弾き語りやソロ活動にも柔軟に対処してくれたKDハポンへ
    僅かばかりではありますが、ライブハウスへの恩返しと支援が出来ればと思い
    「Internal Meeting Compilation」へ参加します。
    また、ライブハウスでお会いしましょう。`,
  },
  {
    id: "nkwors",
    img: "nkwors.jpg",
    name: "猫を堕ろす",
    message: `大学のサークルで結成した我々ですが、初めてサークルから飛び出してライブした場所がKDハポンでした。なっちゃんが加入して初めてのライブもハポンだった...はずです。それからハポンにもデイトリップにも何度出演したかわかりません。沢山お世話になった、沢山の楽しい思い出のある二つのライブハウスの力に少しでもなれれば幸いです。`,
  },
  {
    id: "sukida",
    img: "sukidadramas.jpg",
    name: "sukida dramas",
    message: `僕らの活動を語る上でハポンは絶対に外せません。
    レコ発などのバンドの大事なタイミングではハポンでイベントを組み、楽しい思いや悔しい思いをたくさんして成長させてもらいました。
    良い出会いもたくさんありました。この企画の発起人である薫人くんのバンド猫を堕ろすと初めて出会ったのもハポンでした。

    名古屋の街にハポンが無いのは考えられません。
    これからも、ずっとハポンで遊んでいたいです。ライブしたいし見たいし、カレーもガパオライスも食べたい。天井から聞こえる電車の音を聞いて「ああ、ハポンって良いなぁ〜」って早く思いたい。そのために全力で支援いたします。

    sukida dramas一同`,
  },
  {
    id: "pari",
    img: "pari.jpg",
    name: "Nishio Daisuke",
    message: `今の自分を形成する沢山の思い出がある大好きな場所を守りたい、自分に出来る事は何かと考えていた時にお話を頂き、企画に参加させて頂きました。1日でも早くいつもの風景が戻って来る事を祈っています。`,
  },
  {
    id: "kondo",
    img: "kondo.jpg",
    name: "近藤圭晃",
    message: `ハポンにリスペクトを込めて一曲作りました。ハポンらぶ。`,
  },
  {
    id: "",
    img: "",
    name: "",
    message: ``,
  },
]

// prettier-ignore
export const SongDef = [
{num: 1, title: "ときめきリサーチ200X", artist: "猫を堕ろす" },
{num: 2, title: "Coffee and Cigarettes (feat. ゆいにしお & masato yamashita)", artist: "KISIMEN" },
{num: 3, title: "BLUE", artist: "sukida dramas" },
{num: 4, title: "窓", artist: "スーベニア" },
{num: 5, title: "岸辺", artist: "3cm.rhythm" },
{num: 6, title: "Nexus", artist: "frenzy cabbage" },
{num: 7, title: "勉強ばっかの青春じゃなくてよかった", artist: "ツブダオ" },
{num: 8, title: "girlfriend", artist: "ゆいにしお" },
{num: 9, title: "女装になったの", artist: "かつ江" },
{num: 10, title: "summer time 団地", artist: "グッドバイモカ" },
{num: 11, title: "呼びごえ", artist: "Sedwig" },
{num: 12, title: "Stand Alone", artist: "Muscle Soul" },
{num: 13, title: "Vast Perpetual Nothing", artist: "HECATOMB" },
{num: 14, title: "Flood of Light", artist: "Ulm" },
{num: 15, title: "靉光", artist: "Aysula" },
{num: 16, title: "ウォーキング", artist: "Monaca yellow city" },
{num: 17, title: "Perch", artist: "近藤圭晃" },
{num: 18, title: "チャイニーズ・パンダ", artist: "POSAKE" },
{num: 19, title: "kiló", artist: "qulague" },
{num: 20, title: "エンチナーダ1", artist: "Ogawa & Tokoro" },
{num: 21, title: "water (feat. sbe)", artist: "Nishio Daisuke" },
{num: 22, title: "Stay Home", artist: "めばゑ" },
{num: 23, title: "自宅", artist: "道草" },
{num: 24, title: "彼女の景色", artist: "modern-times" },
{num: 25, title: "幽鬱（スプリーン/ディスタンス)", artist: "ミヤフジサカヱ" },
{num: 26, title: "NEVER BREED", artist: "FUZZKLAXON" },
{num: 27, title: "ポメランク(Forever Mix)", artist: "こみゅにけいしょん" },
{num: 28, title: "凪の向こう", artist: "ゼローネ" },
{num: 29, title: "violet (feat. motokinsella)", artist: "ワタナベヒロト" },
{num: 30, title: "Bloom", artist: "TAMIW" },
{num: 31, title: "am5", artist: "ophill" },
]
